import { ErrorString, InvalidOperationException } from "../../shared/index.js";
export const singleOrDefaultAsync = async (source, predicate) => {
    let hasValue = false;
    let singleValue = null;
    for await (const value of source) {
        if (await predicate(value)) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneMatchingElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    return singleValue;
};
